import { render, staticRenderFns } from "./baseEdit.vue?vue&type=template&id=4f52e208&scoped=true"
import script from "./baseEdit.vue?vue&type=script&lang=js"
export * from "./baseEdit.vue?vue&type=script&lang=js"
import style0 from "./baseEdit.vue?vue&type=style&index=0&id=4f52e208&prod&lang=css"
import style1 from "./baseEdit.vue?vue&type=style&index=1&id=4f52e208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f52e208",
  null
  
)

export default component.exports